import React from 'react';
import { createAppSwitcherBffThirdPartyProductsProvider } from './app-switcher-bff-third-party-products-provider';
var _ref = createAppSwitcherBffThirdPartyProductsProvider(),
  fetchAppSwitcherBffThirdPartyProducts = _ref.fetchMethod,
  DefaultBffThirdPartyProductsDataProvider = _ref.ProviderComponent;
export var ThirdPartyProductsProvider = function ThirdPartyProductsProvider(_ref2) {
  var cloudId = _ref2.cloudId,
    children = _ref2.children,
    product = _ref2.product;
  return /*#__PURE__*/React.createElement(DefaultBffThirdPartyProductsDataProvider, {
    cloudId: cloudId,
    product: product
  }, children);
};
export var prefetchThirdPartyProducts = fetchAppSwitcherBffThirdPartyProducts;
export var resetThirdPartyProducts = function resetThirdPartyProducts() {
  return fetchAppSwitcherBffThirdPartyProducts.reset();
};